import { environment } from '@env/environment';

const { apiUrl } = environment;

/**
 * ### **LanguageEndpoint**
 *
 * Los endpoints son las URLs de un API o un backend que responden a una petición, en este caso las relacionada a los
 * nombres de variables en un idioma especifico.
 */
export class LanguageEndpoint {
  /** Endpoint que retorna la información de titulos y subtitulos de la app web según un idioma especificado.*/
  static languages = `${apiUrl}general/language/`;
  static languages2 = `${apiUrl}language/`;
}
